import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Badge } from 'react-bootstrap';


const TicketsCategory = ({ title, number, percentage, icon, badgeColor }) => {
    return (
        <div>
            <h3 className="fs-3 d-flex align-items-center text-700 mb-1">
                {number}
                <Badge pill bg="transparent" className={classNames(badgeColor, 'px-0 fs--1')}>
                    <FontAwesomeIcon icon={icon} className="fs--2 ms-2 me-1" />
                    {percentage}
                </Badge>
            </h3>
            <h6 className="fs--2 text-600 mb-0 text-nowrap">{title}</h6>
        </div>
    );
};

TicketsCategory.propTypes = {
    title: PropTypes.string.isRequired,
    number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    percentage: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    badgeColor: PropTypes.string
};

export default TicketsCategory;